export default "__VITE_ASSET__ba869e55__"